import {
	depositAnindaCreditCard,
	depositAnindaMFT,
	depositApay,
	depositBankTransfer,
	depositBankTransferCepbank,
	depositBetterBro,
	depositCoinsPaid,
	depositCrypto,
	depositCryptoPayment,
	depositDeltapay,
	depositFXcuzdan,
	depositFixturka,
	depositGuvenilirQR,
	depositIxirpay,
	depositMFT,
	depositMiniHavale,
	depositMonetix,
	depositMovenPay,
	depositMovenPayPapara,
	depositNuvei,
	depositOdebitir,
	depositOdendibilCepbankQR,
	depositOdendibilPep,
	depositPaparaFast,
	depositPaparazzi,
	depositPayco,
	depositPayturka,
	depositPenapay,
	depositPiastrix,
	depositPromotional,
	depositSTP,
	depositSapphirePapara,
	depositSkrill,
	depositThorpay,
	depositTrend,
	depositTrezuz,
	depositTurboHavale,
	depositTurboYatirim,
	depositUnlimit,
	depositVcreditos,
	depositVevopay,
	depositVpag,
	getActiveDepositMethods,
	getBankList,
	getDepositBonuses,
	getFilteredDepositBonuses,
	getOdendibilBankList,
	getSms,
	newCustomer,
	paymentStatus,
	smsStatus,
} from "@actions/deposit";
import ArrowRight from "@pages/profile-v2/assets/icons/ArrowRight.jsx";

import * as paymentLogos from "./../../assets/paymentLogos/onwhite";

import { getConversionRates } from "@actions/balance";
import { getUserInfo } from "@actions/profile.js";
import { showAlert } from "@components/alert/action.js";
import PrevIcon from "@components/icons/prev";
import Loading from "@components/loading/index.jsx";
import {
	DepositButton,
	DepositContentWrapper,
	DepositFeature,
	DepositFeatures,
	DepositItem,
	DepositLogoWrapper,
	DepositMinMax,
	DepositNameDesktop,
	DepositNameFeaturesWrapper,
	DepositNameMobile,
	DepositNameWrapper,
	DepositValueWrapper,
	GRID_WRAPPER,
	Icon,
	ImgWrapper,
	MinMaxWrapper,
	MinOrMax,
	NavigationItem,
	NavigationItemWrapper,
	Text,
	Value,
} from "@pages/profile-v2/pages/deposit/baseItems.js";
import getDepositItems from "@pages/profile-v2/pages/deposit/depositItems";
import Result from "@pages/profile-v2/pages/deposit/result";
import { formatMoney } from "@pages/profile-v2/utils";
import SubPage from "@pages/profile/subPage.jsx";
import Form from "antd/lib/form";
import React from "react";
import { Translate, getActiveLanguage, getTranslate } from "react-localize-redux";
import { connect } from "react-redux";
import { findGroupByPaymentMethod } from "./depositGroupMap";

export class Deposit extends SubPage {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			hoverItem: "",
			currentPage: 1,
			autoOpenMethodName: null,
			selectedGroup: null,
		};
	}

	async componentDidMount() {
		this.setState({ ...this.state, showHeader: false, showSidebar: false });
		this.props.getUserInfo();
		this.props.getActiveDepositMethods();
		this.props.getDepositBonuses();
		this.props.getConversionRates(this.props.userCurrency);

		const { location } = this.props;
		if (location && location.search && location.search.indexOf("openMethod") > -1) {
			const openMethod = location.search.split("openMethod=");
			if (openMethod && openMethod.length > 0) {
				this.setState({ autoOpenMethodName: openMethod[1] });
			}
		}
		if (location && location.search && location.search.indexOf("transaction_id") > -1) {
			this.setState({ currentPage: 3 });
		}
		window?.dataLayer?.push({
			event: "deposit_list",
		});
	}

	componentDidUpdate(prevProps) {
		const { location } = this.props;
		if (
			location?.search?.indexOf("transaction_id") === -1 &&
			prevProps?.location?.search?.indexOf("transaction_id") > -1
		) {
			this.setState({ currentPage: 1 });
		}
	}

	getPageHeader(t) {
		return t("DEPOSIT");
	}

	onBackToDepositPage = () => {
		this.setState({
			currentPage: 1,
		});
	};

	onSelectDeposit = (item) => {
		if (item.items) {
			this.setState({
				selectedGroup: item.name,
			});
		} else {
			this.setState({
				currentPage: 2,
				selectedDeposit: item,
				selectedGroup: null,
			});
		}
	};

	getCurrencyIcon(code) {
		if (code === "EUR") {
			return String.fromCharCode(8364);
		} else if (code === "TRY") {
			return String.fromCharCode(8378);
		} else {
			return;
		}
	}

	getCurrencyOfMethod(currencies) {
		const { wallet } = this.props;
		if (wallet && wallet.total) {
			let currencyNeedShowing = currencies.find(
				(element) => element.currency === wallet.total.currency
			);
			if (currencyNeedShowing) {
				return currencyNeedShowing;
			}
		}
		// NOTE: It can be reverted in the prod environment
		return currencies[0] ? currencies[0] : null;
	}

	filterDepositItems = (depositItems) => {
		const { paymentMethods, bonusList } = this.props;
		let resultItems = [];
		if (paymentMethods?.length > 0) {
			for (let i = 0; i < depositItems.length; i++) {
				let item = depositItems[i];
				let element = paymentMethods.find(
					(element) => element.method.toUpperCase() == item.id.toUpperCase()
				);
				item.bonusList = item.bonusList.concat(
					bonusList
						? bonusList.filter(
								(b) => b.paymentMethods && b.paymentMethods.includes(item.id)
							)
						: []
				);
				if (element && element.currencies) {
					item.currencies = element.currencies;
					item.order = element.order;
					resultItems.push(item);
				}
			}
		}
		return resultItems;
	};

	sortMethods(a, b) {
		if (a.order < b.order) {
			return -1;
		}
		if (a.order > b.order) {
			return 1;
		}
		return 0;
	}

	setHoverItem(hoverItem) {
		this.setState({ hoverItem });
	}

	formatDepositName(name) {
		if (!name) return "";

		if (name === "BETTERBRO PIX" && window.TENANT === "mars-br") {
			return "PIX";
		}

		return name
			.split(" ")
			.map((word) =>
				/^[A-Z]+$/.test(word) ? word : word.replace(/([A-Z](?=[a-z]))/g, " $1").trim()
			)
			.join(" ");
	}
	renderDepositItem(item, index) {
		const { hoverItem } = this.state;
		const { selectedCurrency } = this.props;
		const currencyToUse = selectedCurrency || item.currencies?.[0]?.currency;
		return (
			<Translate>
				{({ translate }) => (
					<DepositItem
						isColorful={window.IS_BOARD_WRAPPER_COLORFUL}
						hasMinMax={window.DEPOSIT_MIN_MAX_VISIBLE}
						key={`deposit-key-${index}`}
						onMouseEnter={() => this.setHoverItem(item.id)}
						onMouseLeave={() => this.setHoverItem("")}>
						<DepositLogoWrapper>
							<ImgWrapper>
								<img
									className={`bank-img ${item.logoCls}`}
									src={item.logo}
								/>
							</ImgWrapper>
							<DepositNameMobile>
								{this.formatDepositName(item.logoName || item.name)}
							</DepositNameMobile>
						</DepositLogoWrapper>
						<DepositContentWrapper>
							{window.DEPOSIT_MIN_MAX_VISIBLE && (
								<MinMaxWrapper isHover={hoverItem === item.id}>
									{this.getCurrencyOfMethod(item.currencies) && (
										<DepositMinMax>
											<DepositValueWrapper>
												<Value
													data-testid={`label-deposit-method-min-${item.id}`}>
													{" "}
													{formatMoney(
														this.getCurrencyOfMethod(item.currencies)
															.deposit.min,
														currencyToUse
													)}{" "}
												</Value>
												<MinOrMax> (MIN) </MinOrMax>
											</DepositValueWrapper>
											<DepositValueWrapper>
												<Value
													data-testid={`label-deposit-method-max-${item.id}`}>
													{" "}
													{formatMoney(
														this.getCurrencyOfMethod(item.currencies)
															.deposit.max,
														currencyToUse
													)}{" "}
												</Value>
												<MinOrMax> (MAX) </MinOrMax>
											</DepositValueWrapper>
										</DepositMinMax>
									)}
								</MinMaxWrapper>
							)}
							<DepositNameWrapper>
								<DepositNameDesktop
									data-testid={`button-deposit-method-${item.id}-title`}>
									{this.formatDepositName(item.logoName || item.name)}
								</DepositNameDesktop>
								<DepositNameFeaturesWrapper isHover={hoverItem === item.id}>
									<DepositFeatures>
										<DepositFeature
											data-testid={`button-deposit-method-${item.id}-subtitle`}>
											{item.id === "APayDeposit" ? (
												<div className="deposit-feature-items">
													<p>BankAlFalah</p>
													<p>Bkash_a</p>
													<p>Bkash_b</p>
													<p>JazzCash</p>
													<p>Mpesa</p>
													<p>NagadA</p>
													<p>NagadB</p>
													<p>UpiP2P</p>
												</div>
											) : (
												item.feature
											)}
										</DepositFeature>
									</DepositFeatures>
								</DepositNameFeaturesWrapper>
							</DepositNameWrapper>
						</DepositContentWrapper>
						<DepositButton
							data-testid={`button-deposit-method-${item.id}`}
							id={item.id}
							isHover={hoverItem === item.id}
							onClick={this.onSelectDeposit.bind(this, item)}>
							<Icon>
								<ArrowRight />
							</Icon>
							<Text>{translate("SELECT")}</Text>
						</DepositButton>
					</DepositItem>
				)}
			</Translate>
		);
	}

	groupDepositItems(depositItems) {
		if (!window.GROUP_BY_DEPOSIT_GROUP) return depositItems;

		let groupedItems = depositItems.reduce((acc, item) => {
			const group = findGroupByPaymentMethod(item.id);
			if (group) {
				const groupItem = acc.find((x) => x.name === group);
				if (groupItem) {
					groupItem.items.push(item);
				} else {
					acc.push({
						id: group,
						logo: paymentLogos[group],
						name: group,
						items: [item],
						order: 1,
					});
				}
			} else {
				acc.push(item);
			}
			return acc;
		}, []);
		//If a group item has just one item, it will be ungrouped
		groupedItems = groupedItems.map((item) => {
			if (item.items?.length === 1) {
				return item.items[0];
			}
			return item;
		});

		groupedItems.forEach((group) => {
			if (group.items && group.items.length > 1) {
				group.items.sort(this.sortMethods);
			}
		});

		return groupedItems;

		// if a deposit item has a group and GROUP_BY_DEPOSIT_GROUP is true, it will be grouped, if not, it will be grouped by id
		//and when a group item is selected, all other items will be hidden, and grouped items will be shown
		// depositItems = depositItems.reduce((acc, item) => {
		// 	if (item.group && window.GROUP_BY_DEPOSIT_GROUP) {
		// 		const groupItem = acc.find((x) => x.name === item.group);
		// 		if (groupItem) {
		// 			groupItem.items.push(item);
		// 		} else {
		// 			acc.push({
		// 				logo: paymentLogos[item.group],
		// 				name: item.group,
		// 				items: [item],
		// 			});
		// 		}
		// 	} else {
		// 		acc.push(item);
		// 	}
		// 	return acc;
		// }, []);
	}

	getPageContent() {
		const layout = {
				wrapperCol: { span: 70 },
			},
			{ currentPage, selectedDeposit, autoOpenMethodName, selectedGroup } = this.state,
			{ loading, wallet, showAlert, user, availableBonuses, depositLoading } = this.props;
		let depositItems = getDepositItems({ props: this.props });
		depositItems = this.filterDepositItems(depositItems);
		depositItems = this.groupDepositItems(depositItems);

		if (autoOpenMethodName && depositItems.find((x) => x.id === autoOpenMethodName)) {
			this.setState({
				selectedDeposit: depositItems.find((x) => x.id === autoOpenMethodName),
				autoOpenMethodName: null,
				currentPage: 2,
			});
		}

		window.xx = depositItems;
		return (
			<div className="cube-form-wrapper">
				<Loading loading={loading} />
				<Form
					{...layout}
					layout="vertical"
					name="basic"
					hideRequiredMark={true}
					initialValues={{ remember: true }}>
					<GRID_WRAPPER
						data-testid="step-deposit-method-selection"
						hasLessBorderRadius={window.HAS_LESS_BORDER_RADIUS}
						isSub={currentPage != 1}>
						{
							///////////////////
							//DEPOSIT SELECTION
							///////////////////
							currentPage === 1 &&
								!selectedGroup &&
								depositItems
									?.sort?.(this.sortMethods)
									?.map?.((item, index) => this.renderDepositItem(item, index))
						}
						{selectedGroup &&
							depositItems
								.find((x) => x.name === selectedGroup)
								.items.map((item, index) => this.renderDepositItem(item, index))}
					</GRID_WRAPPER>
					<div>
						{
							//////////////
							//PAYMENT STEP
							//////////////
							currentPage === 2 && (
								<selectedDeposit.component
									selectedDeposit={selectedDeposit}
									showAlert={showAlert}
									user={user}
									loading={depositLoading}
									availableBonuses={availableBonuses}
									onBackToDepositPage={this.onBackToDepositPage.bind(this)}
									externalFunc={
										typeof selectedDeposit.externalFunc === "object"
											? selectedDeposit.externalFunc
											: this.props[selectedDeposit.externalFunc]
									}
									wallet={wallet}
								/>
							)
						}

						{
							////////////////////
							/////RESULT PAGE////
							////////////////////
							currentPage === 3 && <Result />
						}
					</div>
					{selectedGroup && (
						<NavigationItemWrapper>
							<NavigationItem
								data-testid="step-deposit-nav-back"
								back={true}
								onClick={() => this.setState({ selectedGroup: null })}>
								<PrevIcon />
							</NavigationItem>
						</NavigationItemWrapper>
					)}
				</Form>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	bonusList: state.bonus.bonus.bonusList,
	availableBonuses: state.bonus.filteredBonuses,
	loading: state.deposit.loading,
	depositLoading: state.balance.depositLoading,
	wallet: state.balance.wallet,
	convertionRates: state.balance.convertionRates,
	user: state.profile.user,
	paymentMethods: state.deposit.paymentMethods,
	languages: state.localize.languages,
	currentLanguage: getActiveLanguage(state.localize).code,
	userCurrency: state.balance.currency,
	translate: getTranslate(state.localize),
});

const mapDispatchToProps = {
	depositMFT,
	depositPenapay,
	depositFixturka,
	depositThorpay,
	depositIxirpay,
	depositDeltapay,
	depositCrypto,
	depositCryptoPayment,
	depositMiniHavale,
	newCustomer,
	depositUnlimit,
	getBankList,
	depositPaparazzi,
	depositBankTransfer,
	depositMonetix,
	depositMovenPay,
	depositFXcuzdan,
	depositSapphirePapara,
	depositPromotional,
	depositTrend,
	depositTrezuz,
	depositMovenPayPapara,
	depositPaparaFast,
	depositVevopay,
	depositTurboHavale,
	depositTurboYatirim,
	showAlert,
	getSms,
	smsStatus,
	paymentStatus,
	depositPayturka,
	getUserInfo,
	depositAnindaMFT,
	depositAnindaCreditCard,
	getActiveDepositMethods,
	getOdendibilBankList,
	depositOdendibilCepbankQR,
	depositGuvenilirQR,
	depositPayco,
	depositOdebitir,
	depositBetterBro,
	depositOdendibilPep,
	getDepositBonuses,
	getFilteredDepositBonuses,
	depositPiastrix,
	depositBankTransferCepbank,
	depositCoinsPaid,
	depositApay,
	depositVpag,
	depositVcreditos,
	getConversionRates,
	depositSTP,
	depositSkrill,
	depositNuvei,
};

export default connect(mapStateToProps, mapDispatchToProps)(Deposit);
